import { useListStoreCardsQuery } from "services/storeCards";
import { StoreCard } from "../../../../ui/data-display/Passes/storeCard";
import { createTemplateDashboard } from 'components/reusable/template';


export const StoreCardDashboard = createTemplateDashboard({
  TemplateRenderer: StoreCard,
  listTemplateHook: useListStoreCardsQuery,
  i18nNamespace: "storeCard"
});